/**
 * 系谱图 — admin binary placement genealogy (网体系谱 + 全球玩家表).
 */
import { Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { AdminGenealogyDrillViewer } from '../../components/AdminGenealogyDrillViewer';
import { AdminGlobalPlayersTable } from './AdminGlobalPlayersTable';
import { AdminOutOfNetworkPlayersTable } from './AdminOutOfNetworkPlayersTable';
import { BinaryTreePage } from './BinaryTreePage';

export function GenealogyChartPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const activeKey =
    tab === 'out' || tab === 'drill' || tab === 'tree' || tab === 'global' ? tab : 'global';

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>系谱图</h2>
      <Tabs
        activeKey={activeKey}
        onChange={(key) => {
          const next = new URLSearchParams(searchParams);
          if (key === 'global') next.delete('tab');
          else next.set('tab', key);
          setSearchParams(next, { replace: true });
        }}
        items={[
          {
            key: 'global',
            label: '全球玩家(表)',
            children: <AdminGlobalPlayersTable />,
          },
          {
            key: 'out',
            label: '非全球玩家',
            children: <AdminOutOfNetworkPlayersTable />,
          },
          {
            key: 'drill',
            label: '网体系谱',
            children: <AdminGenealogyDrillViewer />,
          },
          {
            key: 'tree',
            label: '树形预览',
            children: <BinaryTreePage embedded />,
          },
        ]}
      />
    </div>
  );
}
